import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from "axios";
import global from '../Global.vue'
import store from "../store";
import {
	userInfo
} from '../common/common.js'
import {
	Decrypt,
	Encrypt
} from '@/common/secret.js'

function getQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return unescape(r[2]);
	return null;
}
Vue.use(VueRouter)
const RoundImageWatch = () => import('@/views/exhibition/RoundImageWatch.vue')
const Exhibition = () => import('@/views/exhibition/exhibition.vue')
const ImgTextPerview = () => import('@/views/exhibition/ImgTextPerview.vue')
const Hall = () => import('@/views/exhibition/Hall.vue')
const Page404 = () => import('@/views/exhibition/404.vue')
const PageError = () => import('@/views/exhibition/Error.vue')
const Agreement = () => import('@/views/exhibition/Agreement.vue')
const routes = [{
		path: '/imgtextperview',
		name: 'ImgTextPerview',
		component: ImgTextPerview,
		meta: {
			title: '即刻VR全景漫游'
		}
	},
	{
		path: '/roundimagewatch',
		name: RoundImageWatch,
		component: RoundImageWatch,
		meta: {
			title: '即刻VR全景漫游'
		}
	},
	{
		path: '/exhibition',
		name: Exhibition,
		component: Exhibition,
		meta: {
			title: '即刻VR全景漫游'
		}
	},
	{
		path: '/agreement',
		name: 'agreement',
		component: Agreement,
		meta: {
			title: '协议'
		}
	},
	{
		path: '/watch',
		name: Hall,
		component: Hall,
		meta: {
			title: '即刻VR全景漫游'
		}
	},
	{
		path: '/error',
		name: PageError,
		component: PageError
	},
	{
		path: '*',
		name: '404',
		component: Page404,
		meta: {
			title: '404'
		}
	}
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	let locationUrl = window.location.href;
	if (locationUrl.indexOf("code") >= 0) {
		console.log(locationUrl)
		let path = "/api/phone/callBack";
		let payload = {
			params: {
				code: getQueryString('code'),
				roomId: store.state.hallId,
				entrance: userInfo.isMobile() ? userInfo.getMobileSystem() : 'PC'
			}
		};
		// console.log(store.state.hallId)
		// console.log(getQueryString('code'))
		axios.get(path, payload).then(res => {

				if (res.data.success) {
					// console.log(res)

					if (res.data.openid) {
						store.commit("updataWxUser", res.data.openid);
						console.log('微信登录成功')
						// next();
						let redirectHref = global.SERVER_FRONT_WEB_URL + '/#/watch?roomId=' + Encrypt(store
							.state.hallId);
						window.location.href = redirectHref;
						// console.log(document.location.origin)
						// console.log(document.location.origin)
						// console.log(res)
					} else {
						console.log('登陆失败')

					}
				} else {
					// console.log('有问题')
					window.location.href = global.SERVER_FRONT_WEB_URL + '/#/error';
					// next("/error");
				}
			})
			.catch(err => {
				console.log("数据获取失败" + err);
			});
	} else {
		next();
	}
});
export default router
